module.exports = __webpack_public_path__ + "img/5-img-copy@2x.f7ed2ae4.jpg";